var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSearch(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.9886 12.7198C13.6957 12.4269 13.2208 12.4269 12.9279 12.7198C12.635 13.0127 12.635 13.4875 12.9279 13.7804L13.9886 12.7198ZM15.7611 16.6137C16.054 16.9066 16.5289 16.9066 16.8218 16.6137C17.1147 16.3208 17.1147 15.846 16.8218 15.5531L15.7611 16.6137ZM12.9279 13.7804L15.7611 16.6137L16.8218 15.5531L13.9886 12.7198L12.9279 13.7804ZM7.7915 13.2084C4.6849 13.2084 2.1665 10.69 2.1665 7.58337H0.666504C0.666504 11.5184 3.85648 14.7084 7.7915 14.7084V13.2084ZM13.4165 7.58337C13.4165 10.69 10.8981 13.2084 7.7915 13.2084V14.7084C11.7265 14.7084 14.9165 11.5184 14.9165 7.58337H13.4165ZM7.7915 1.95837C10.8981 1.95837 13.4165 4.47677 13.4165 7.58337H14.9165C14.9165 3.64834 11.7265 0.458374 7.7915 0.458374V1.95837ZM7.7915 0.458374C3.85648 0.458374 0.666504 3.64834 0.666504 7.58337H2.1665C2.1665 4.47677 4.6849 1.95837 7.7915 1.95837V0.458374Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearch);
export default __webpack_public_path__ + "static/media/search.dbfc92773aa6ee35558d0f0e4325cf45.svg";
export { ForwardRef as ReactComponent };